// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.417 15c-.996 1.793-2.857 3-4.989 3-3.181 0-5.76-2.686-5.76-6s2.579-6 5.76-6c2.132 0 3.993 1.207 4.99 3h7.02c.28 0 .55.116.747.322l2.299 2.395a1.131 1.131 0 0 1-.06 1.612l-3.223 2.878a1.023 1.023 0 0 1-1.32.045l-1.283-1.002-1.277.998a1.025 1.025 0 0 1-1.38-.102L12.84 15zm.781-2c.28 0 .549.116.747.322l.823.858 1.196-.935a1.022 1.022 0 0 1 1.268 0l1.246.974 1.988-1.775L19.08 11h-7.933c-.426-1.725-1.93-3-3.719-3-2.12 0-3.84 1.79-3.84 4s1.72 4 3.84 4c1.79 0 3.293-1.275 3.719-3zm-3.85-1c0 1.105-.86 2-1.92 2s-1.92-.895-1.92-2 .86-2 1.92-2 1.92.895 1.92 2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessKey;
